<template>
    <div class="literature-detail">
        <div class="content" v-if="detail">
            <h1 class="title" v-text="detail.title"></h1>
            <div class="row">
                <div class="creator" v-text="`作者: ${detail.author} 教授`"></div>
                <div class="create-time"><a-icon type="calendar" class="icon"/>{{detail.createdtime.substring(0, 10)}}</div>
            </div>
            <div class="content-wrapper">
                <p v-text="detail.introduce"></p>
                <div v-html="detail.content">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            detail: null,
        }
    },
    mounted: function(){
        this.detail = JSON.parse(sessionStorage.getItem('detail'))
    },
    watch: {
        '$route.params.id': function(id) {
            this.detail = JSON.parse(sessionStorage.getItem('detail'))
        },
    }
}
</script>

<style scoped>
    .literature-detail {
        display: flex;
        flex-direction: column;
        background-color: #fff;
        padding: 0 24px;
        position: relative;
        border: 1px solid #e8e8e8;
        box-shadow: 1px 1px 1px #e9e7e7;
    }

    .literature-detail .title {
        line-height: 30px;
        text-align: center;
        font-size: 28px;
        font-weight: bold;
        color: #1f1f1f;
        margin-top: 40px;
    }
    
    .literature-detail .row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        height: 42px;
    }

    .literature-detail .creator {
        font-size: 14px;
        font-weight: 400;
        color: #232323;
        line-height: 16px;
        margin-right: 24px;
    }

    .literature-detail .create-time {
        font-size: 14px;
        font-weight: 400;
        color: #666;
        line-height: 16px;
        position: relative;
    }

    .literature-detail .create-time > .icon {
        margin-right: 4px;
    }

    .literature-detail .content-wrapper p {
        font-size: 16px;
        font-weight: 400;
        color: #232323;
        line-height: 24px;
    }

    .literature-detail .content-wrapper img {
        width: 100%;
        object-fit: contain;
    }
</style>
